//FireBase Digimevo.-clinic





exports.firebaseConfig = {
    //apiKey: "AIzaSyDsPufr5Dhusqal0bB8VDD9N6yv9u0Lo1E",
    //authDomain: "tester-8e38d.firebaseapp.com",
    //databaseURL: "https://tester-8e38d.firebaseio.com",
    //projectId: "tester-8e38d",
    //storageBucket: "tester-8e38d.appspot.com",
    //messagingSenderId: "490493205074"
	
    apiKey: "AIzaSyDJpcsbF8uGbjgLUFKzx3NqvgXTxoIZFTs",
    authDomain: "digimevo-clinic-console.firebaseapp.com",
    databaseURL: "https://digimevo-clinic-console.firebaseio.com",
    projectId: "digimevo-clinic-console",
    storageBucket: "digimevo-clinic-console.appspot.com",
    messagingSenderId: "54075225687"


};

//App setup
exports.adminConfig={
  "appName": "Digimevo",
  "slogan":"Digital Medical Evolution.",
  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"green", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"black", // "white | black"
  },
  "showItemIDs":false,
  "allowedUsers":null, //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":true, //Allowed users must contain list of allowed users in order to use google auth
  "fieldBoxName": "Datos",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":["-event"],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":false,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"YOUR_KEY",

  "fieldsTypes":{
    "photo":["photo","foto_promocion_equipo","icono_personal","logo_hora","qr_codigo","image","logo","photo_vertical","foto_personal","portada","portada1","portada2","portada3","portada4"],
    "imagelocked":["preview"],
    "categorias":["categories_videos"],
    "idcategorias":["seleccion_categorias","categorias_relacionadas"],
    "videos":["seleccion_videos","videos_relacionados"],
    "videofiltered":["seleccion_videos_playlist"],
    "idplaylists":["idplaylist"],
    "secciones":["secciones_relacionadas","secciones_medicas"],
    "equipo":["equipo_seccion"],
    "esponsors":["esponsors_vetados"],
    "sliderhandles":["distribucion_tiempo_pantalla","distribucion_tiempo_promociones"],
    "slidervariable":["duracion_video_anuncio","instagram_imagenes","numero_promociones_por_video","promocions_time_sec","frecuencia_videos_promocion","frecuencia_promocion_tablet"],
    "videoupload":["video","video_promocion"],
    "horario":["horario_visitas","horario_centro"],
    "sliderlabels":["promocions_size","sub_size","letra_promocion","turno_size","eslogan_tablet_size"],
    "actualizaciones":["actualizar_promociones_equipo","añadir_playlist","actualizar_videos_disponibles","añadir_video","añadir_promocion","añadir_equipo","añadir_seccion"],
    "toggle":["twitter_offline_mostrar","instagram_feed","promocion_equipo_tv","twitter_mostrar","esponsors","tv","app","tablet","seccion_activa","tiempo_animado","forzar_descarga","eslogan_tablet_mostrar","mostrar_color_fondo","inteligencia_artificial","audio","mostrar_texto","promocion_activa"],
    "link":["preview_video","video_demo"],
    "dateTime":["end","start","created","updated"],
    "map":["map","latlng","location"],
    "textarea":["description"],
    "html":["content","texto_promocion","texto_promocion_equipo"],
    "radio":["radio","radiotf","formato_seccion","featured","tipo_banner_superior","tipo_banner_inferior","tipo_promocion_relacionada","idioma_configuracion","video_type"],
    "checkbox":["checkbox","metodo_reserva_cita","metodo_contacto","idioma","video_plan","video_idioma","tipo_promo","instagram_tipo_promocion","video_idioma_corporativo","categories_videos_zona1","categories_videos_zona2","categories_videos_zona3","categories_videos_zona4","categories_videos_zona5"],
    "dropdowns":["status","dropdowns","posicio","posicion_equipo","tipo_clinica","tipo_transicion","fuente"],
    "file":["sub_es","sub_ca","sub_en"],
    "rgbaColor":['rgba'],
    "hexColor":['color','sub_back','color_twitter','eslogan_tablet_fondo','eslogan_tablet_color','sub_color','color_fondo_promo','color_letra_promo','colorPrimari','colorSecundari','colorPrimari_playlist','colorSecundari_playlist'],
    "relation":['type','creator',"video_seccion_1","video_seccion_2","video_seccion_3","video_seccion_4","video_seccion_5","video_seccion_6","video_seccion_7","video_seccion_8","video_seccion_9","video_seccion_10","categoria_anuncios_1","categoria_anuncios_2","categoria_anuncios_3","categoria_anuncios_4","categoria_anuncios_5","categoria_medica_01","categoria_medica_02","categoria_medica_03","categoria_medica_04","categoria_medica_05","categoria_medica_06","categoria_medica_07","categoria_medica_08","categoria_medica_09","categoria_medica_10","categoria_medica_11","categoria_medica_12","categoria_medica_13","categoria_medica_14","categoria_medica_15",'categories1',"categories2",'categories3',"categories4",'categories5'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
    "iconio":['iconio'],
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"start", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"created", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"updated", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
  ],
  "optionsForSelect":[
      {"key":"foto_promocion_equipo","options":["512x768"]},
      {"key":"icono_personal","options":["335x214"]},
      {"key":"logo_hora","options":["500x166"]},
      {"key":"logo","options":["500x166"]},
      {"key":"photo","options":["H768x512 V512x768"]},
      {"key":"photo_vertical","options":["263x375"]},
      {"key":"foto_personal","options":["670x500"]},
      {"key":"portada","options":["768x512"]},
      {"key":"portada1","options":["768x512"]},
      {"key":"portada2","options":["768x512"]},
      {"key":"portada3","options":["768x512"]},
      {"key":"portada4","options":["768x512"]},
      {"key":"seleccion_videos_playlist","options":["tv"]},
      {"key":"añadir_equipo","options":["Añadir Equipo",1000]},
      {"key":"añadir_promocion","options":["Añadir_Promocion",1000]},
      {"key":"añadir_playlist","options":["Añadir Playlist",1000]},
      {"key":"añadir_video","options":["Añadir Video",1000]},
      {"key":"añadir_seccion","options":["Añadir Seccion",1000]},
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"status","options":["just_created","confirmed","canceled"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"twitter_offline_mostrar","options":["true","false"]},
      {"key":"featured","options":["true","false"]},
      {"key":"actualizar_promociones_equipo","options":["Actualizar",1000]},
      {"key":"actualizar_videos_disponibles","options":["Actualizar",5000]},
      {"key":"frecuencia_videos_promocion","options":["1","10","videos"]},
      {"key":"instagram_imagenes","options":["1","20","imagenes"]},
      {"key":"numero_promociones_por_video","options":["1","20","promociones"]},
      {"key":"frecuencia_promocion_tablet","options":["1","100","segundos"]},
      {"key":"distribucion_tiempo_pantalla","options":["tratamientos","capsulas","corporativos","promociones","esponsors"]},
      {"key":"distribucion_tiempo_promociones","options":["manual","social","equipo"]},
      {"key":"promocions_time_sec","options":["1","100","segundos"]},
      {"key":"duracion_video_anuncio","options":["1","30","segundos"]},
      {"key":"idioma","options":["español","català","english","français","german","italiano","portugues"]},
      {"key":"video_plan","options":["standard","premium","dentalplay"]},
      {"key":"video_idioma","options":["español","català","english","français","german","italiano","portugues"]},
      {"key":"video_idioma_corporativo","options":["español","català","english","français","german","italiano","portugues"]},
      {"key":"idioma_configuracion","options":["español","català","english","français","german","italiano","portugues"]},
      {"key":"instagram_tipo_promocion","options":["banner_tv", "banner_tablet", "banner_app", "imagen_video_tv", "imagen_video_tablet", "imagen_video_app"]},
      {"key":"tipo_promo","options":["banner_tv", "banner_tablet", "banner_app", "imagen_video_tv", "imagen_video_tablet", "imagen_video_app"]},
     // {"key":"categories_videos","options":["Nosotros","Ansiedad","Andrología","Alimentación","Infecciones","Podología","Vacunas","Dolor de Espalda","Dolor de Cabeza y Migraña","Salud Mental","Hábitos Saludables","Psicología","Infertilidad","Diabetes","Gripe","Psiquiatría","Obesidad","Cansancio","Acupuntura","Alergólogos","Mi Salud","Alergias","Osteoporosis","Radiología","Reumatología","Traumatología","Problemas Sexuales","Hipertensión","Odontología","Analistas Clínicos","Medicina Estética","Actividad Física","Anestesistas","Naturopatia","Cirugía","Cardiología","Dolores de Estomago e Intestivo Irritable","Dentistas","Salud y Seguridad","Medicamentos","Dermatólogos","Dietistas","Endocrinos","Digestologo","Medicina del Deporte","Medicina Preventiva","Atención primaria","Fisioterapia","Estrés","Ginecólogo","Homopatia","Resfriado","Medicina China","Logopeda","Dolores Cervicales y Contracturas","Médico de Família","Urologia","Médicos estéticos","Caída del Cabello","Dolores Menstruales","Neumologia","Psoariasis","Oftalmologia","Sudoración","Hematologia","Problemas Respiratorios","Óptica","Otorrino","Pediatría","Kids"]},
      {"key":"categories_videos_zona2","options":["Nosotros","Ansiedad","Andrología","Alimentación","Infecciones","Podología","Vacunas","Dolor de Espalda","Dolor de Cabeza y Migraña","Salud Mental","Hábitos Saludables","Psicología","Infertilidad","Diabetes","Gripe","Psiquiatría","Obesidad","Cansancio","Acupuntura","Alergólogos","Mi Salud","Alergias","Osteoporosis","Radiología","Reumatología","Traumatología","Problemas Sexuales","Hipertensión","Odontología","Analistas Clínicos","Medicina Estética","Actividad Física","Anestesistas","Naturopatia","Cirugía","Cardiología","Dolores de Estomago e Intestivo Irritable","Dentistas","Salud y Seguridad","Medicamentos","Dermatólogos","Dietistas","Endocrinos","Digestologo","Medicina del Deporte","Medicina Preventiva","Atención primaria","Fisioterapia","Estrés","Ginecólogo","Homopatia","Resfriado","Medicina China","Logopeda","Dolores Cervicales y Contracturas","Médico de Família","Urologia","Médicos estéticos","Caída del Cabello","Dolores Menstruales","Neumologia","Psoariasis","Oftalmologia","Sudoración","Hematologia","Problemas Respiratorios","Óptica","Otorrino","Pediatría","Kids"]},
      {"key":"categories_videos_zona3","options":["Nosotros","Ansiedad","Andrología","Alimentación","Infecciones","Podología","Vacunas","Dolor de Espalda","Dolor de Cabeza y Migraña","Salud Mental","Hábitos Saludables","Psicología","Infertilidad","Diabetes","Gripe","Psiquiatría","Obesidad","Cansancio","Acupuntura","Alergólogos","Mi Salud","Alergias","Osteoporosis","Radiología","Reumatología","Traumatología","Problemas Sexuales","Hipertensión","Odontología","Analistas Clínicos","Medicina Estética","Actividad Física","Anestesistas","Naturopatia","Cirugía","Cardiología","Dolores de Estomago e Intestivo Irritable","Dentistas","Salud y Seguridad","Medicamentos","Dermatólogos","Dietistas","Endocrinos","Digestologo","Medicina del Deporte","Medicina Preventiva","Atención primaria","Fisioterapia","Estrés","Ginecólogo","Homopatia","Resfriado","Medicina China","Logopeda","Dolores Cervicales y Contracturas","Médico de Família","Urologia","Médicos estéticos","Caída del Cabello","Dolores Menstruales","Neumologia","Psoariasis","Oftalmologia","Sudoración","Hematologia","Problemas Respiratorios","Óptica","Otorrino","Pediatría","Kids"]},
      {"key":"categories_videos_zona4","options":["Nosotros","Ansiedad","Andrología","Alimentación","Infecciones","Podología","Vacunas","Dolor de Espalda","Dolor de Cabeza y Migraña","Salud Mental","Hábitos Saludables","Psicología","Infertilidad","Diabetes","Gripe","Psiquiatría","Obesidad","Cansancio","Acupuntura","Alergólogos","Mi Salud","Alergias","Osteoporosis","Radiología","Reumatología","Traumatología","Problemas Sexuales","Hipertensión","Odontología","Analistas Clínicos","Medicina Estética","Actividad Física","Anestesistas","Naturopatia","Cirugía","Cardiología","Dolores de Estomago e Intestivo Irritable","Dentistas","Salud y Seguridad","Medicamentos","Dermatólogos","Dietistas","Endocrinos","Digestologo","Medicina del Deporte","Medicina Preventiva","Atención primaria","Fisioterapia","Estrés","Ginecólogo","Homopatia","Resfriado","Medicina China","Logopeda","Dolores Cervicales y Contracturas","Médico de Família","Urologia","Médicos estéticos","Caída del Cabello","Dolores Menstruales","Neumologia","Psoariasis","Oftalmologia","Sudoración","Hematologia","Problemas Respiratorios","Óptica","Otorrino","Pediatría","Kids"]},
      {"key":"categories_videos_zona5","options":["Nosotros","Ansiedad","Andrología","Alimentación","Infecciones","Podología","Vacunas","Dolor de Espalda","Dolor de Cabeza y Migraña","Salud Mental","Hábitos Saludables","Psicología","Infertilidad","Diabetes","Gripe","Psiquiatría","Obesidad","Cansancio","Acupuntura","Alergólogos","Mi Salud","Alergias","Osteoporosis","Radiología","Reumatología","Traumatología","Problemas Sexuales","Hipertensión","Odontología","Analistas Clínicos","Medicina Estética","Actividad Física","Anestesistas","Naturopatia","Cirugía","Cardiología","Dolores de Estomago e Intestivo Irritable","Dentistas","Salud y Seguridad","Medicamentos","Dermatólogos","Dietistas","Endocrinos","Digestologo","Medicina del Deporte","Medicina Preventiva","Atención primaria","Fisioterapia","Estrés","Ginecólogo","Homopatia","Resfriado","Medicina China","Logopeda","Dolores Cervicales y Contracturas","Médico de Família","Urologia","Médicos estéticos","Caída del Cabello","Dolores Menstruales","Neumologia","Psoariasis","Oftalmologia","Sudoración","Hematologia","Problemas Respiratorios","Óptica","Otorrino","Pediatría","Kids"]},
      {"key":"app","options":["true","false"]},
      {"key":"fuente","options":["acme","anton","boogaloo","cabin","gothic","lato","opensans","sansnarrow","sans","ubuntu","varela","worksans"]},
      {"key":"video_type","options":["tratamiento_propio","promociones_propio","corporativo"]},
      {"key":"metodo_reserva_cita","options":["telefono","whatsapp","correo_electronico","cita_online"]},
      {"key":"tipo_banner_inferior","options":["tiempo","hora","imagen","vacio"]},
      {"key":"tipo_banner_superior","options":["tiempo","hora","imagen","vacio"]},
      {"key":"metodo_contacto","options":["telefono_fijo","telefono_movil","whatsapp","skype","correo_electronico","zoom"]},
      {"key":"tablet","options":["true","false"]}, 
      {"key":"tv","options":["true","false"]},
      {"key":"esponsors","options":["true","false"]},
      {"key":"promocion_equipo_tv","options":["true","false"]},
      {"key":"formato_seccion","options":["categorias","tags","videos"]},
      {"key":"tipo_clinica","options":["consulta_privada","clinica_especialista","políclinca","hospital"]},
      {"key":"tipo_promocion_relacionada","options":["secciones","categorias","videos","no relacionada"]},
      {"key":"tipo_transicion","options":["normal","fade"]},
      {"key":"posicion_equipo","options":["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75","76","77","78","79","80","81","82","83","84","85","86","87","88","89","90","91","92","93","94","95","96","97","98","99","100","101","102","103","104","105","106","107","108","109","110","111","112","113","114","115","116","117","118","119","120","121","122","123","124","125","126","127","128","129","130","131","132","133","134","135","136","137","138","139","140","141","142","143","144","145","146","147","148","149","150","151","152","153","154","155","156","157","158","159","160","161","162","163","164","165","166","167","168","169","170","171","172","173","174","175","176","177","178","179","180","181","182","183","184","185","186","187","188","189","190","191","192","193","194","195","196","197","198","199","200"]},
      {"key":"posicio","options":["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75","76","77","78","79","80","81","82","83","84","85","86","87","88","89","90","91","92","93","94","95","96","97","98","99","100","101","102","103","104","105","106","107","108","109","110","111","112","113","114","115","116","117","118","119","120","121","122","123","124","125","126","127","128","129","130","131","132","133","134","135","136","137","138","139","140","141","142","143","144","145","146","147","148","149","150","151","152","153","154","155","156","157","158","159","160","161","162","163","164","165","166","167","168","169","170","171","172","173","174","175","176","177","178","179","180","181","182","183","184","185","186","187","188","189","190","191","192","193","194","195","196","197","198","199","200"]},
  ],
  "optionsForRelation":[
      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categories1",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categories2",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categories3",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categories4",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categories5",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },



// XAVI CATEGORIES ANUNCIS


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_anuncios_1",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_anuncios_2",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_anuncios_3",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_anuncios_4",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
         {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_anuncios_5",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_01",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_02",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_03",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_04",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_05",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_06",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_07",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_08",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_09",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_10",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_1",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_2",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_3",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_4",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_5",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },



      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_6",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_7",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_8",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_9",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "video_seccion_10",
        "path": "/videos",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },













      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_11",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_12",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_13",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },

      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_14",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },


      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "categoria_medica_15",
        "path": "/categories",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },



      {
        //Firestore - Native
        "display": "title",
        "isValuePath": true,
        "key": "seccions",
        "path": "/seccions",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "title"
      },
     
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 20,
    "finite": true,
    "retainLastPage": false
  },
  "hiddenKeys":["keyToHide","indice","creardentalq","actualizar_promociones_equipo","max_size_image_upload","max_size_video_upload","bio_secret","bio_validate","formato_promo","twitter_velocidad","idequipo","categoria_medica_01","categoria_medica_02","categoria_medica_03","categoria_medica_04","categoria_medica_05","categoria_medica_06","categoria_medica_07","categoria_medica_08","categoria_medica_09","categoria_medica_10","categoria_medica_11","categoria_medica_12","categoria_medica_13","categoria_medica_14","categoria_medica_15","categoria_anuncios_1","categoria_anuncios_2","categoria_anuncios_3","categoria_anuncios_4","categoria_anuncios_5","frecuencia_anuncios_segundos","porcentaje_anuncios","tipo_clinica","zona_geografica","pacientes_unicos","capsules_freq","crearsecciones_propias","corporatius_freq","crearequipo","seccion_tipo","created","video_tipo","crearzonas","descrip","updated","categoria_video","videosdisponiblespremium","videopremiumactive","refclinica","video_plan","video_idioma","crearencuestasyvideoscorporativos","video_demo","zonas","promocio_freq","anotherKeyToHide","clinica","actualizarsecciones","actualizarvideos","video_type_selecciovideos","codi_clinica","codi_clinica_playlist","promoid_1","promoid_2","email","idclinica","administrador","idvideo","idcapsula","preview","preview_video","type","idtractament","web","direccio","telefon","mail","categoria1updatedata_value","categoria2updatedata_value","categoria3updatedata_value","categoria4updatedata_value","categoria5updatedata_value","video_audience_selecciovideos","video_audience","preview_video"],
  "previewOnlyKeys":["previewOnlyKey","a_tags","codigo_personal","videospremiumactuales","codiequipo","videos_premium","premium","premium_dentalplay","anotherPreviewOnlyKye","name","video_demo","idplaylist","nomclinica","nombreclinica","a_clinica","a_title","nom_clinica","preview","codi","clinica"]
}

//Navigation
exports.navigation=[

  /*
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"home",
      "path": "",
       isIndex:true,
   /* },
    {
      "link": "fireadmin",
      "path": "events",
      "name": "Events",
      "icon":"event",
      "tableFields":["name","description"],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "events/skopje/items",
          "name": "Skopje",
          "icon":"event",
          "tableFields":["name","description"]
        },{
          "link": "fireadmin",
          "path": "events/sofia/items",
          "name": "Sofia",
          "icon":"event",
          "tableFields":["name","description"],
        },{
          "link": "fireadmin",
          "path": "events/belgrade/items",
          "name": "Belgrade",
          "icon":"event",
          "tableFields":["name","description"],
        }
      ]
    },
    {
      "link": "fireadmin",
      "path": "clubs",
      "name": "Clubs",
      "icon":"room",
      "tableFields":["name","description"],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "clubs/skopje/items",
          "name": "Skopje",
          "icon":"event",
          "tableFields":["name","description"]
        },{
          "link": "fireadmin",
          "path": "clubs/sofia/items",
          "name": "Sofia",
          "icon":"event",
          "tableFields":["name","description"],
        },{
          "link": "fireadmin",
          "path": "clubs/belgrade/items",
          "name": "Belgrade",
          "icon":"event",
          "tableFields":["name","description"],
        }
      ]
    },
    {
      "link": "fireadmin",
      "path": "userdata/{useruuid}",
      "name": "My Profile",
      "icon": "perm_identity",
      "tableFields":[],
    },
    {
      "link": "fireadmin",
      "path": "bookings",
      "name": "Bookings",
      "icon":"done",
      "tableFields":[],
    },{
      "link": "fireadmin",
      "path": "static",
      "name": "Cities & Genres",
      "icon":"location_city",
      "tableFields":["name","description"],
    },*/
    
    {
      "link": "firestoreadmin",
      "path": "cliniques",
      "name": "Clínicas",
      "icon":"account_balance",
      "tableFields":["nombreclinica","logo","videos_premium","videospremiumactuales"],
   
   
    },

    {
      "link": "firestoreadmin",
      "path": "equipo",
      "name": "Equipo",
      "icon":"people",
      "tableFields":["nombre_apellidos","foto_personal","metodo_contacto","posicion_equipo","promocion_equipo_tv"],
    },

    {
      "link": "firestoreadmin",
      "path": "videos_corporativos",
      "name": "Videos Propios",
      "icon":"music_video",
      "tableFields":["title","photo","forzar_descarga"],
    },
    {
      "link": "firestoreadmin",
      "path": "playlists",
      "name": "Playlists TV",
      "icon":"playlist_play",
      "tableFields":["title","clinica","codi"],

    },{
      "link": "firestoreadmin",
      "path": "promocions",
      "name": "Promociones",
      "icon":"loyalty",
      "tableFields":["title","photo","tipo_promo","promocion_activa"],

    },{
      "link": "firestoreadmin",
      "path": "videos_disponibles",
      "name": "Videos Disponibles",
      "icon":"library_music",
      "tableFields":["a_title","video_type_selecciovideos","video_plan","categoria_video","video_idioma","preview","video_demo","app","tablet","tv"],
    },
    /*
    {
      "link": "firestoreadmin",
      "path": "videos_disponibles",
      "name": "Videos Activos",
      "icon":"perm_media",
      "tableFields":["a_title","a_clinica","video_type_selecciovideos","video_plan","video_idioma","preview","video_demo","tablet","tv","app"],
    },
    */
    {
      "link": "firestoreadmin",
      "path": "enquestes",
      "name": "Encuestas",
      "icon":"assignment",
      "tableFields":["pregunta","clinica"],
    },{
      "link": "firestoreadmin",
      "path": "seccions",
      "name": "Secciones",
      "icon":"dashboard",
      "tableFields":["title","posicio","seccion_tipo","seccion_activa"],

    },{
      "link": "firestoreadmin",
      "path": "counters",
      "name": "Estadísticas",
      "icon":"bar_chart",
      "tableFields":["a_title","clinica","preview","reproduccions"],

    },{
      "link": "biodigital",
      "path": "",
      "name": "Módulos 3D",
      "icon":"3d_rotation",
      "tableFields":[],

  },{
    "link": "push",
    "path": "",
    "name": "Mensajes",
    "icon":"notifications_active",
    "tableFields":[],
  }



 /*   },{
       "link": "firestoreadmin",
      "path": "events",
      "name": "FireStore Events",
      "icon":"event",
      "tableFields":["name"],
    },{
     "link": "link",
      "path": "http://mobidonia.com",
      "name": "Mobidonia.com",
      "icon": "web",
      "tableFields":["name"],*/
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
exports.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"firebase", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AAAAI9Pi3r0:APA91bFu-yuktaj3pveplpRCxikDiMrFPXO49D61yCx59IpseAXCMwvnn3RnPVgVruorhUjWmh2CmGorYa_gokuIxMvh9mQA23A_KxhGmkslSn0NYEYOriWyC4qHaDgrUZaPEv0c9s8l", //Firebase push authorization ket
  "pushTopic":"eOU5XulRHRrvDi783Pc3", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "idclincicapush":"",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

exports.userDetails={

}

exports.remoteSetup=false;
exports.remotePath="admins/mobidonia";
exports.allowSubDomainControl=false;
exports.subDomainControlHolder="admins/";


// WEBPACK FOOTER //
// ./src/config/app.js